import PresidiPrestazioni from "..";

const routes = [
  {
    name: "PresidiPrestazioni",
    path: "/presidiprestazioni",
    component: PresidiPrestazioni.PresidiPrestazioniListPage,
    meta: { title: "Lista Presidi - Prestazioni" },
  },
  {
    name: "PresidiPrestazioniEdit",
    path: "/presidiprestazioni/edit/:id",
    component: PresidiPrestazioni.PresidiPrestazioniEditPage,
    meta: { title: "Crea Prestazione Presidio" },
  }
];

export default routes;
